import { Tenant } from "./tenant";
import { ServerDate } from "@eres/core";
import Strings from "@my-dld/assets/strings";

export interface ContractCore {
	ContractId?: number;
	ContractNumber?: string;
	ContractKey?: string;
	ContractEndDate?: ServerDate;
	ContractStartDate?: ServerDate;
}

export interface ContractDiscount {
	DiscountTypeId?: number;
	DiscountValue?: number;
}

export interface ContractFinanceCore extends ContractDiscount {
	AssociatedContractAnnualCosts?: ContractAnnualCosts[];
	EjariPropertyID?: number;
	GraceEndDate?: ServerDate;
	GraceStartDate?: ServerDate;
	ContractValueType?: number;
	ContractTenantNameAr?: string;
	ContractTenantNameEn?: string;
}

export interface ContractComputeRequest extends ContractFinanceCore {
	EndDate?: ServerDate;
	StartDate?: ServerDate;
	ContractValue?: number;
}

export interface ContractFinance extends ContractComputeRequest {
	CalculatedContractStartDate?: ServerDate;
	CalculatedContractEndDate?: ServerDate;
	ContractActualAnnualValue?: number;
	ContractActualValue?: number;
	ContractAnnualValue?: number;
	Errors?: number;
	HousingFees?: number;
	IsGracePeriod?: boolean;
}

export interface ContractAnnualCosts extends ContractDiscount {
	StartDate?: ServerDate;
	EndDate?: ServerDate;
	Value?: number;
	YearRatio?: number;
	ActualValue?: number;
	AnnualValue?: number;
}

export enum PaymentType {
	CHEQUE = 1,
	CASH = 2,
}

export const PAYMENT_CASH = {
	"Id": PaymentType.CASH,
	"Name": Strings.cash,
};
export const PAYMENT_CHEQUE = {
	"Id": PaymentType.CHEQUE,
	"Name": Strings.cheque,
};
export const EJARI_PAYMENT_PLAN_TYPES = [ PAYMENT_CASH, PAYMENT_CHEQUE ];

export interface ContractPayment {
	Amount?: string;
	BankName?: string;
	BankId?: number;
	ChequeNumber?: string;
	InstallmentDueDate?: ServerDate;
	PaymentType?: PaymentType;
	PaymentTypeId?: PaymentType;
}

export interface ContractTerm {
	ArabicTerm?: string;
	EnglishTerm?: string;
	TermId?: number;
}

export interface PreDefinedTemplate {
	Description?: string;
	NameAr?: string;
	NameEn?: string;
	Identity?: number;
}

export interface PreDefinedTerm {
	DescriptionAr?: string;
	DescriptionEn?: string;
	ContractTypeId?: number;
	Identity?: number;
}

export interface ContractFee {
	Amount?: number;
	FeeNameAr?: string;
	FeeNameEn?: string;
	Description?: string;
	FeeCode?: string;
	FeeType?: number;
}

export interface Contract extends ContractCore, ContractFinanceCore {
	ContractAmount?: number;
	TenancyContractId?: number;
	SecurityDeposit?: string;
	ContractTypeId?: number;
	IsGracePeriod?: boolean;
	ContractAnnualCosts?: ContractAnnualCosts[];
	ContractDiscountTypeId?: number;
	ContractDiscountValue?: number;
	Errors?: any;
	AdditionalTerms?: ContractTerm[];
	Tenants?: Tenant[];
	TotalCoTenants?: number;
	EjariPropertyId?: number[];
	PrimaryOwnerParticipantId?: string;
	ActiveUserType?: number;
	ActiveUserID?: string;
	ManagementCompanyId?: string;
	OwnersParticipantId?: string;
	IsTenantApprovalReq?: number;
	PaymentAction?: number;
	PaymentPlan?: ContractPayment[];
	// from server
	Fees?: ContractFee[];
	ContractValidationErrors?: number[];
	ReceiptNumber?: string;
	TenantEmail?: string;
	TenantMobileNumber?: string;
	Url?: string;
	// seriously id in ids out
	EjariPropertyIds?: number[];
	DewaMoveinDate?: ServerDate;
	DewaMoveoutDate?: ServerDate;
	DewaMoveoutRequestno?: string;
	Remarks?: string;
	ContractStatusId?: number;
	HazardousMaterialClassRels?: number[];
}

export interface PayByTenantRequest {
	contractNumber: string;
	mobile: string;
	email: string;
}

export interface PayByTenantResponse {
	EMAIL: true;
	SMS: true;
}

export interface MoveOut {
	DewaMoveinDate?: ServerDate;
	DewaMoveoutDate?: ServerDate;
	DewaMoveoutcontractNumber?: string;
	DewaMoveoutRequestno?: string;
}

export interface ValidateDewaMoveOut extends MoveOut {
	EjariPropertyId: number[];
	ContractStartDate: string;
	ContractEndDate: string;
	Tenants?: Tenant[];
}

export interface TerminateRequest {
	AdminEmailAddress?: string;
	ContractId?: string;
	ActiveUserID?: string;
	ActiveUserType?: number;
	TerminationDate?: ServerDate;
	TerminationReasonId?: number;
	TerminationReasonText?: string;
	RegistrationContractType?: number;
}

export enum ContractValueType {
	EntirePeriod = 1,
	PerYear = 2
}


export enum ContractDiscountType {
	None = 1,
	Fixed = 2,
	Percent = 3
}
